import React from 'react';

// Inline colored SVG flags for the supported delivery countries. We draw them
// rather than use emoji regional-indicator flags because Windows renders those
// as plain letter codes (no color). viewBox keeps the coordinates simple; the
// rendered size is fixed at 18x12 so they line up in the order-list row.
const FLAG_SVG = {
  RO: (
    <svg viewBox="0 0 3 2" width="18" height="12">
      <rect x="0" width="1" height="2" fill="#002B7F" />
      <rect x="1" width="1" height="2" fill="#FCD116" />
      <rect x="2" width="1" height="2" fill="#CE1126" />
    </svg>
  ),
  BG: (
    <svg viewBox="0 0 3 3" width="18" height="12">
      <rect y="0" width="3" height="1" fill="#FFFFFF" />
      <rect y="1" width="3" height="1" fill="#00966E" />
      <rect y="2" width="3" height="1" fill="#D62612" />
    </svg>
  ),
  HU: (
    <svg viewBox="0 0 3 3" width="18" height="12">
      <rect y="0" width="3" height="1" fill="#CD2A3E" />
      <rect y="1" width="3" height="1" fill="#FFFFFF" />
      <rect y="2" width="3" height="1" fill="#436F4D" />
    </svg>
  ),
  GR: (
    <svg viewBox="0 0 27 18" width="18" height="12">
      <rect width="27" height="18" fill="#0D5EAF" />
      <g fill="#FFFFFF">
        <rect y="2" width="27" height="2" />
        <rect y="6" width="27" height="2" />
        <rect y="10" width="27" height="2" />
        <rect y="14" width="27" height="2" />
      </g>
      <rect width="10" height="10" fill="#0D5EAF" />
      <g fill="#FFFFFF">
        <rect x="4" width="2" height="10" />
        <rect y="4" width="10" height="2" />
      </g>
    </svg>
  )
};

const CountryFlag = ({ code }) => {
  const flag = FLAG_SVG[(code || '').toUpperCase()];
  if (!flag) return null;

  return (
    <span
      style={{
        display: 'inline-flex',
        lineHeight: 0,
        borderRadius: 2,
        overflow: 'hidden',
        boxShadow: '0 0 0 1px rgba(0,0,0,0.12)'
      }}
    >
      {flag}
    </span>
  );
};

export default CountryFlag;
